module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.products.length),
      expression: "!products.length"
    }]
  }, [_c('i', [_vm._v("Please add some products to cart.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.products.length > 0),
      expression: "products.length > 0"
    }]
  }, [_c('table', {
    staticClass: "checkout-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.products), function(p) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: p.id
          }
        }
      }
    }, [_vm._v(_vm._s(p.title))])], 1), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(p.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.quantity))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(p.price * p.quantity))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total"
  }, [_vm._m(1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(_vm.total))])])], 2)]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "checkout-button",
    attrs: {
      "disabled": !_vm.products.length
    },
    on: {
      "click": function($event) {
        _vm.checkout(_vm.products)
      }
    }
  }, [_vm._v("Checkout")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkoutStatus),
      expression: "checkoutStatus"
    }]
  }, [_vm._v("Checkout " + _vm._s(_vm.checkoutStatus) + ".")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Per Unit")]), _vm._v(" "), _c('th', [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("TOTAL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e309336"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CartPage.vue
// module id = 95
// module chunks = 1